import React from "react";

const AwardCard = ({ award }) => (
    <div className="border rounded shadow m-4 max-w-md bg-white">
        <img src={award.imgSrc} alt={award.title} className="w-full h-48 object-cover rounded-t" />
        <div className="p-4">
            <h3 className="text-xl font-semibold">{award.title}</h3>
            <p className="text-gray-600">{award.date} — {award.location}</p>
            <p className="mt-2">{award.description}</p>
        </div>
    </div>
);

export default AwardCard;
